import { render } from "./ShippingMethodBasicInfo.vue?vue&type=template&id=83abce0e&scoped=true&ts=true"
import script from "./ShippingMethodBasicInfo.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodBasicInfo.vue?vue&type=script&lang=ts"

import "./ShippingMethodBasicInfo.vue?vue&type=style&index=0&id=83abce0e&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83abce0e"]])

export default __exports__